import React, { useEffect, useRef } from "react";

const ServicesTech = () => {
  const titleRef = useRef(null);
  // const paraRef = useRef(null);
  const paraRef1 = useRef(null);
  // const datadetailRef = useRef(null);
  // const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            // Remove class when element goes out of view so it re-triggers on scroll again
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const elements = [
      titleRef.current,
      // paraRef.current,
      paraRef1.current,
      // datadetailRef.current,
      // imgRef.current,
    ];
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return (
    <div className="container-fluid  pb-5">
      <div className="container">
        <div className="row">
          <div
            ref={titleRef}
            className="title_line text-center p-5 animate-title"
          >
            Our Services
          </div>
          <div id="services">
            <p class="text-center animate-para visible">
              From software development to IT consulting, we craft solutions
              that drive efficiency and innovation. Partner with us to transform{" "}
              <br></br>
              ideas into impactful digital experiences.
            </p>
          </div>
          <div className="col-md-12 mt-4">
            <div className="row equal  animate-para" ref={paraRef1}>
              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    devices_other
                  </span>
                  <div className="title_services">
                    Full-stack Microsoft <br /> Services
                  </div>
                  <p className="services_info_txt">
                    Struggling with disconnected devices, underused licenses, or
                    costly inefficiencies? We build a Microsoft ecosystem that’s
                    fully integrated, easy to manage, and built for measurable
                    ROI.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    devices
                  </span>
                  <div className="title_services">
                    Custom Software <br /> Development
                  </div>
                  <p className="services_info_txt">
                    Is your team wasting time on manual tasks, battling
                    workarounds, and relying on outdated systems? We build
                    software tailored to your exact workflows to save time, cut
                    costs, and scale effortlessly.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    settings
                  </span>

                  <div className="title_services">
                    Custom ERP & <br /> CRM Software Development
                  </div>
                  <p className="services_info_txt">
                    Losing leads, facing data silos, or juggling multiple
                    platforms? We help you centralize and automate operations
                    with ERP & CRM systems built to solve your real business
                    needs.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    network_intelligence
                  </span>
                  <div className="title_services">
                    Mobile Application <br /> Development
                  </div>
                  <p className="services_info_txt">
                    Dealing with slow apps, high user drop-offs, or poor
                    engagement? We build mobile solutions that load fast, work
                    flawlessly, and keep users hooked.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    smart_toy
                  </span>
                  <div className="title_services">
                    Machine Learning & <br /> Artificial Intelligence
                  </div>
                  <p className="services_info_txt">
                    Overwhelmed by data, missing growth opportunities, or making
                    slow decisions? Use AI & ML to predict trends, automate
                    processes, uncover revenue potential faster, and more.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    cloud_download
                  </span>
                  <div className="title_services">
                    IoT Cloud Servers & <br /> Hosting
                  </div>
                  <p className="services_info_txt">
                    Experiencing downtime, rising maintenance costs, and
                    security gaps? We help you deploy IoT infrastructure that’s
                    scalable, reliable, and protected around the clock.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    data_exploration
                  </span>
                  <div className="title_services">
                    IT Strategic <br /> Consulting
                  </div>
                  <p className="services_info_txt">
                    Investing heavily in IT but not seeing the real business
                    impact? Get a clear, actionable roadmap that aligns
                    technology with long-term growth and measurable returns.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>

              <div className="col-md-4 p-2">
                <div className="services_box  h-100 d-flex flex-column">
                  <span class="material-icons material-symbols-outlined">
                    group
                  </span>
                  <div className="title_services">
                    Dedicated Team <br />
                    Hiring
                  </div>
                  <p className="services_info_txt">
                    Facing delivery delays, skill shortages, and rising
                    recruitment costs? Get access to a high-performing team
                    ready to execute complex IT projects from day one.
                  </p>
                  <button className="btn btn-primary text-center  mt-auto">
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesTech;
